export const WEB_SEARCH_RESULT_ATTACHMENT_NAME = 'WEB_SEARCH_RESULT_ATTACHMENT';
//# sourceMappingURL=bff-card-attachments.js.map